import animation from './animation';
import common from './common';
import input from './input';

export default { animation, common, input };
